import classNames from "classnames";
import { isEmoji } from "common/Support";
import { GlideFC } from "lib/glide-fc";
import FormElement, { FormElementProps } from "../form-element/form-element";
import { InlinePivotViewStyle, ItemWrapper } from "./inline-pivot-view-style";

interface Props extends FormElementProps {
    items: readonly string[];
    current: number;

    className?: string;

    onClick: (index: number) => void;
    formatItem?: (item: string) => string;
}

const InlinePivotView: GlideFC<Props> = props => {
    const { className, items, current, title: header, onClick, formatItem } = props;

    const children = items.slice(0, 5).map((val, index) => {
        return (
            <ItemWrapper
                className={classNames({
                    current: index === current,
                    prior: index === current - 1,
                })}
                data-test="app-inline-picker-item"
                key={index}
                onClick={() => onClick(index)}
                isEmoji={header !== undefined && isEmoji(header)}>
                <div>{formatItem === undefined ? val : formatItem(val)}</div>
            </ItemWrapper>
        );
    });

    return (
        <FormElement {...props}>
            <InlinePivotViewStyle className={className} data-test="app-inline-picker">
                {children}
            </InlinePivotViewStyle>
        </FormElement>
    );
};

export default InlinePivotView;
